<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title" v-text="pageTitle"></h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <form-navigation-tabs
              :tabs="tabs"
              v-on:selected="setActive"
              :active="currentView"
            ></form-navigation-tabs>

            <div v-if="currentView == 'details'">
              <inputbox
                v-model="form.name"
                name="name"
                label="Name"
                :required="true"
                :error-message="form.errors.get('name')"
                :show-error="form.errors.has('name')"
              ></inputbox>

              <inputbox
                v-model="form.telephone"
                name="telephone"
                label="Telephone"
              ></inputbox>
              <inputbox
                v-model="form.email"
                :error-message="form.errors.get('email')"
                :required="true"
                :show-error="form.errors.has('email')"
                name="email"
                type="email"
                label="Email Address"
              ></inputbox>

              <inputbox
                v-model="form.company_number"
                :error-message="form.errors.get('company_number')"
                :required="true"
                :show-error="form.errors.has('company_number')"
                name="company_number"
                type="text"
                label="Company Number"
              ></inputbox>

              <inputbox
                v-model="form.vat_number"
                :error-message="form.errors.get('vat_number')"
                :required="true"
                :show-error="form.errors.has('vat_number')"
                name="vat_number"
                type="text"
                label="VAT Number"
              ></inputbox>

              <toggleswitch
                :labels="true"
                v-model="form.active"
                name="active"
                label="Active"
              ></toggleswitch>

              <toggleswitch
                :labels="true"
                v-model="form.generate_vehicle_hire_agreement"
                name="active"
                label="Generate Vehicle Hire Agreements?"
              ></toggleswitch>

              <file-input
                name="logo"
                label="Logo"
                :required="true"
                :show-error="form.errors.has('logo')"
                v-on:selected="setLogo"
                :error-message="form.errors.get('logo')"
              ></file-input>
            </div>
            <offices
              v-if="currentView == 'offices'"
              :offices="form.offices"
              v-on:updated="updateOffices"
            ></offices>
            <modules v-if="currentView == 'modules'"></modules>
            <settings
              v-if="currentView == 'settings'"
              :credit-hire-organisation="creditHireOrganisation"
            ></settings>
            <users v-if="currentView == 'users'"></users>
            <document-templates
              v-if="currentView == 'document-templates'"
            ></document-templates>
          </div>
          <div class="card-footer text-right" v-if="currentView == 'details'">
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="submit"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Offices from './Form/Offices.vue';
import Users from './Form/Users.vue';
import Modules from './Form/Modules.vue';
import Settings from './Form/Settings.vue';
import DocumentTemplates from './Form/DocumentTemplates.vue';
import PageHeader from './../Modules/Shared/PageHeader.vue';

export default {
  props: {
    creditHireOrganisation: {
      type: String,
      required: false
    }
  },

  components: {
    Offices,
    Modules,
    Users,
    Settings,
    DocumentTemplates,
    PageHeader
  },

  data() {
    return {
      currentView: 'details',
      form: new window.Form({
        name: null,
        telephone: null,
        email: null,
        company_number: null,
        vat_number: null,
        active: true,
        generate_vehicle_hire_agreement: true,
        offices: [],
        enabledModules: []
      }),
      tabs: [
        {
          name: 'details',
          label: 'Details',
          disabled: false
        }
      ],
      modules: [],
      draggingKey: null
    };
  },

  computed: {
    exists() {
      if (this.creditHireOrganisation) {
        return true;
      }

      return false;
    },

    pageTitle() {
      if (this.exists) {
        return 'Edit Credit Hire Organisation';
      }

      return 'Create Credit Hire Organisation';
    }
  },

  mounted() {
    if (this.creditHireOrganisation) {
      this.findCreditHireOrganisation();
      this.addTabs(false);
    } else {
      this.addTabs(true);
    }
  },

  methods: {
    setLogo(data) {
      this.form.addFile(data.name, data.file);
    },

    updateOffices(offices) {
      this.offices = offices;
    },

    addTabs(disabled) {
      this.tabs.push(
        {
          name: 'offices',
          label: 'Offices',
          disabled: disabled
        },
        {
          name: 'modules',
          label: 'Modules',
          disabled: disabled
        },
        {
          name: 'settings',
          label: 'Settings',
          disabled: disabled
        },
        {
          name: 'users',
          label: 'Users',
          disabled: disabled
        },
        {
          name: 'document-templates',
          label: 'Document Templates',
          disabled: disabled
        }
      );
    },

    setActive(view) {
      this.currentView = view;
    },

    submit() {
      let method = 'post';
      let url = '/credit-hire-organisations';

      if (this.creditHireOrganisation) {
        method = 'put';
        url = `/credit-hire-organisations/${this.creditHireOrganisation}`;
      }

      this.form[method](url)
        .then(response => {
          this.route(`/credit-hire-organisations/${response.identifier}`);
          window.toastify.success(
            'Saved',
            'The credit hire organisation was saved successfully!'
          );
        })
        .catch(error => {
          window.swal(
            'Oops...',
            'Sorry, there was a problem creating the credit hire organisation.',
            'error'
          );
        });
    },

    findCreditHireOrganisation() {
      window.Ajax.get(
        '/credit-hire-organisations/' + this.creditHireOrganisation
      )
        .then(response => {
          this.form.name = response.data.name;
          this.form.email = response.data.email;
          this.form.company_number = response.data.company_number;
          this.form.vat_number = response.data.vat_number;
          this.form.telephone = response.data.telephone;
          this.form.active = response.data.active;
          this.form.offices = response.data.offices;
          this.form.generate_vehicle_hire_agreement =
            response.data.generate_vehicle_hire_agreement;

          this.activateTabs();
        })
        .catch(err => {});
    },

    activateTabs() {
      this.tabs.forEach(item => {
        item.disabled = false;
      });
    }
  },

  watch: {
    creditHireOrganisation(value) {
      if (value) {
        this.findCreditHireOrganisation();
      }
    }
  }
};
</script>
